( function() { // eslint-disable-line
    var pluginName = 'leasePicker';
    var Pikaday = require('pikaday');
    var i18n = require('./pickaday-i18n');
    var lang = document.documentElement.lang;

    // Constructor
    function leasePicker( selector ) {
        this.config = {
            from: '[lease-picker="from"]',
            to: '[lease-picker="to"]'
        };

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.leaseFrom = this.selector.querySelector(this.config.from);
        this.leaseTo = this.selector.querySelector(this.config.to);
        this.startPicker = null;
        this.endPicker = null;
        this.startDate = null;
        this.endDate = null;

        // Init
        this.init();
    }

    leasePicker.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            // ready
            var instance = this;
            instance.startPicker = new Pikaday({
                field: instance.leaseFrom,
                format: 'YYYY/MM/DD',
                yearRange: 100,
                i18n: lang === 'fr' ? i18n.fr : i18n.en,
                minDate: this.leaseFrom ? this.leaseFrom.getAttribute('min-date') === 'today' ? new Date() : null : null,
                onSelect: function() {
                    instance.startDate = this.getDate();
                    instance.endDate = instance.endPicker.getDate();
                    if (instance.endDate === null) {
                        instance.endDate = instance.addOneYear(instance.startDate);
                        instance.endPicker.setDate(instance.endDate);
                    }
                    instance.updateStartDate();
                }
            });
            instance.endPicker = new Pikaday({
                field: instance.leaseTo,
                format: 'YYYY/MM/DD',
                yearRange: 100,
                i18n: lang === 'fr' ? i18n.fr : i18n.en,
                onSelect: function() {
                    instance.endDate = this.getDate();
                    instance.updateEndDate();
                }
            });

            var _startDate = instance.startPicker.getDate();
            var _endDate = instance.endPicker.getDate();

            if (_startDate) {
                instance.startDate = _startDate;
                instance.updateStartDate();
            }

            if (_endDate) {
                instance.endDate = _endDate;
                instance.updateEndDate();
            }
        }
    };

    leasePicker.prototype.updateStartDate = function updateStartDate() {
        this.startPicker.setStartRange(this.startDate);
        this.endPicker.setStartRange(this.startDate);
        this.endPicker.setMinDate(this.startDate);
    };

    leasePicker.prototype.updateEndDate = function updateEndDate() {
        this.startPicker.setEndRange(this.endDate);
        this.endPicker.setEndRange(this.endDate);
    };

    leasePicker.prototype.addOneYear = function addOneYear(d) {
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate() - 1; // minus one day
        return new Date(year + 1, month, day);
    };

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = leasePicker;

}());
